import {
  FloorTypename,
  MinimalProject,
  ProductPositionTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import {
  MinimalFloor,
  RecursiveMinimalFloorWithParent
} from "entities/floors/types/Floor"
import {
  MinimalProductPosition,
  RecursiveMinimalProductPositionWithParent
} from "entities/product-positions/types/ProductPosition"
import {
  MinimalRoom,
  RecursiveMinimalRoomWithParent
} from "entities/rooms/types/Room"

export function formatProjectElementTitleForEntityList(
  entity: MinimalProject | MinimalFloor | MinimalRoom | MinimalProductPosition,
  fallback?: string | null | undefined
) {
  if (!entity) {
    return fallback ?? "-"
  }

  if (entity.__typename === "Project") {
    return entity.title ?? "-"
  }

  if (entity.__typename === "Floor") {
    return entity.label ?? "-"
  }

  if (entity.__typename === "Room") {
    if (!entity.number || !entity.label) {
      return entity.number || entity.label || "-"
    }
    return `${entity.number} ${entity.label}`
  }

  if (entity.__typename === "ProductPosition") {
    if (entity.displayPosition && entity.variantKey) {
      return `${entity.displayPosition} ${entity.variantKey}`
    }

    return entity.displayPosition ?? entity.variantKey ?? "-"
  }

  return fallback ?? "-"
}

export function formatProjectElementParentTitlesForEntityList(
  entity:
    | MinimalProject
    | RecursiveMinimalProductPositionWithParent
    | RecursiveMinimalRoomWithParent
    | RecursiveMinimalFloorWithParent,
  options?: { skipProject: boolean }
): string[] {
  if (!entity) {
    return []
  }

  if (entity.__typename === ProjectTypename) {
    return []
  }

  if (
    entity.__typename === ProductPositionTypename ||
    entity.__typename === RoomTypename ||
    entity.__typename === FloorTypename
  ) {
    return [
      formatProjectElementTitleForEntityList(entity),
      ...formatProjectElementParentTitlesForEntityList(entity.parent, options)
    ]
  }

  return []
}
